//import MenuFlipBook from "../components/MenuFlipBook/MenuFlipBook";
import ImageSider from "../components/ImageSider";
//import { useNavigate } from "react-router-dom";
const pages = ["/menu3/s1_1000.png", "/menu3/s2_1000.png"];

const SevenIslandMenu = () => {
  // const navigate = useNavigate();
  // const handleReservation = () => {
  //   navigate("/reservations");
  //   window.scrollTo(0, 0);
  // };
  const handleReservation = () => {
    window.open("https://resy.com/cities/edison-nj/venues/house-of-bombay");
  };
  return (
    <section className="menu-section" id="thesevenislandmenu">
      <div className="hero-border-menu">
        <div className="menu-container">
          <div className="inner-menu-container">
            <h2 className="menu-title">The Seven Island Menu  (Coming Soon)</h2>

            <p className="menu-text">
              Before it became the city we know today, Bombay was seven separate
              islands. This seven-course tasting menu traces those origins,
              using food to explore how geography, trade, migration, and time
              shaped the city’s flavours. Each course is inspired by a place, a
              history, and a culinary influence that helped form
              modern Bombay. Designed as a guided experience, this menu is meant
              to be enjoyed slowly, one course, one story at a time. 
            </p>

            <p className="menu-text">
              A journey through the city’s beginnings, told at the table. 
            </p>

            {/* <p className="par-menu-btn">
              <button className="menu-btn" onClick={() => handleReservation()}>
                BOOK A TABLE
              </button>
            </p> */}
          </div>
          {/* CAROUSEL */}

          {/* <div className="carousel2">
           
            <ImageSider images={pages} />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default SevenIslandMenu;
